/* DSCPLN — IntersectionObserver-driven scroll reveal. Respects prefers-reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-dscpln-reveal]').forEach(function (el) {
      el.classList.add('dscpln-reveal--in');
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-dscpln-reveal]').forEach(function (el) {
      el.classList.add('dscpln-reveal--in');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dscpln-reveal--in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  function boot() {
    document.querySelectorAll('[data-dscpln-reveal]:not(.dscpln-reveal--in)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
